// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { satisfies } from 'semver';
import Vue from 'vue';
import Vuex from 'vuex';
import VueToast from 'vue-toast-notification';
import Vuelidate from 'vuelidate';
import VueCountryCode from "vue-country-code";
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';
import App from './App';
import router from './router';

Vue.use(Vuex);
Vue.use(VueCountryCode);
Vue.use(Vuelidate);
Vue.use(VueToast, {
  position: "top-right"
});

Vue.config.productionTip = false;

const store = new Vuex.Store({
  state: {
    firstName: "",
    lastName: "",
    countryName: "",
    packageAmount: 0,
    selectedPackage: "",
  },
  mutations: {
    selectedPackage (state, payload) {
      state.selectedPackageInfo = payload;
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store: store,
});



// WEBPACK FOOTER //
// ./src/main.js